import { render, staticRenderFns } from "./ListPartner.vue?vue&type=template&id=2cd68108&"
import script from "./ListPartner.vue?vue&type=script&lang=js&"
export * from "./ListPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports